module.exports = __webpack_public_path__ + "static/img/miura_01.c9b558c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/miura_01.png
// module id = XH5r
// module chunks = 0